import React from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

function usePublicUserId() {
  try {
    const raw = localStorage.getItem('userData') || localStorage.getItem('user');
    if (!raw) return null;
    return JSON.parse(raw)?.id || null;
  } catch {
    return null;
  }
}

export default function LearnPage() {
  const currentUserId = usePublicUserId();

  const articles = [
    {
      title: 'Dear John',
      desc: 'Real yard and plant questions, answered honestly. AI goes first, John adds his take.',
      to: '/learn/dear-john',
    },
    {
      title: 'How a landscape project usually works',
      desc: 'From first conversation to installation - what to expect at each step.',
      to: '/learn/project-basics',
    },
    {
      title: 'Choosing a designer you click with',
      desc: 'Questions to ask and green flags to look for before you sign on.',
      to: '/learn/choosing-a-designer',
    },
    {
      title: 'Quick seasonal tips',
      desc: 'Ideas you can act on this season without a full redesign.',
      to: '/learn/seasonal-tips',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <PublicNav currentUserId={currentUserId} />
      <main className="flex-1 max-w-3xl mx-auto px-4 py-10 sm:py-14">
        <h1 className="text-3xl font-bold text-gray-900">Learn</h1>
        <p className="mt-3 text-gray-600 leading-relaxed">
          Practical guides for homeowners—how projects work, how to pick help, and how to think about your yard in
          seasons.
        </p>
        <ul className="mt-10 space-y-4">
          {articles.map((a) => (
            <li key={a.to}>
              <Link
                to={a.to}
                className="block rounded-xl border border-gray-200 bg-white p-5 shadow-sm hover:border-green-300 hover:shadow transition-all"
              >
                <h2 className="font-semibold text-gray-900">{a.title}</h2>
                <p className="mt-1 text-sm text-gray-600">{a.desc}</p>
                <span className="mt-2 inline-block text-sm font-medium text-green-700">Read →</span>
              </Link>
            </li>
          ))}
        </ul>
        <p className="mt-10 text-sm text-gray-500">
          More articles are on the way. For now, explore{' '}
          <Link to="/ideas" className="text-green-700 font-medium hover:underline">
            yard ideas
          </Link>{' '}
          or{' '}
          <Link to="/watch" className="text-green-700 font-medium hover:underline">
            watch &amp; tips
          </Link>
          .
        </p>
      </main>
      <Footer />
    </div>
  );
}
